import { IconCheck, IconClose } from "app/components/Icon/Icon";
import { FormattedMessage } from "react-intl";

const VerificationStatus = (props: Record<string, any>) => {
  const { verifiedStatus, verifiedStatusFormatedText } = props;
  return (
    <div className="verification__status">
      {verifiedStatus ? (
        <span className="account-menu--status__status--verified">
          <span className="status__text">
            <FormattedMessage tagName="span" id="settings-status" />
          </span>
          {verifiedStatusFormatedText}{" "}
          <IconCheck
            className="account-menu--status__icon"
            currentColor={true}
          />
        </span>
      ) : (
        <div>
          <span className="account-menu--status__status--unverified">
            <span className="status__text">
              <FormattedMessage tagName="span" id="settings-status" />
            </span>
            {verifiedStatusFormatedText}
            <IconClose
              className="account-menu--status__icon--close"
              currentColor={true}
            />
          </span>
        </div>
      )}
    </div>
  );
};

export default VerificationStatus;
